import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { AvailableFutureDates } from 'components/availableFutureDates';
import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';

const NoAvailablePrices = ({ message, variant }) => {
    const { availableFutureDates, isFetching, noPricesMessage } =
        useSelector((state) => state?.noAvailablePrices) || {};

    return (
        <div className={`ab-no-prices-cnt--${variant}`}>
            <div className={`ab-no-prices-msg ab-no-prices-msg--${variant}`}>
                {noPricesMessage || message}
            </div>

            {isFetching ? (
                <BarsLoadingIndicator
                    classes="ab-bars-loading-indicator--light-gray ab-loader-center"
                    style={{ marginTop: '8px' }}
                />
            ) : (
                <AvailableFutureDates dates={availableFutureDates || []} />
            )}
        </div>
    );
};

NoAvailablePrices.defaultProps = {
    variant: 'desktop',
};

NoAvailablePrices.propTypes = {
    message: PropTypes.string,
    variant: PropTypes.oneOf(['mobile', 'desktop']),
};

export default NoAvailablePrices;
